// A helper for feature chains. Feature chain items can now have parameters.
// The raw data for the item is as follows (each item is a string with : separated values):
//
//      {featureId}:{startType}:{startDelay}:{endType}
//
// We split this string into an array of objects with the following properties, here are some usefule contants for accessing them.

export const CHAINS_HELPER = {
    PARAM_INDEXES: {
        FEATURE_ID: 0,
        START_TYPE: 1,
        START_DELAY: 2,
        END_TYPE: 3,
    },
    START_TYPE_AUTO: 'auto',
    START_TYPE_MANUAL: 'manual',
    END_TYPE_FEATURE_END: 'feature_end',
    END_TYPE_IMMEDIATE: 'immediate',
}
